// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__26qAJ","content":"LayoutSettings_content__3-tS3"};